import React from 'react';
import jMoment from 'moment-jalaali';
import {
    FormControl,
    FormControlLabel,
    FormLabel,
    Paper,
    RadioGroup,
    Radio,
    Avatar,
    Button,
    InputLabel, InputAdornment,
    Chip,
    TextField,
    Input
} from 'material-ui';
import {Done, Clear, AddAlert, Search, DoneAll, LibraryBooks} from 'material-ui-icons';
import ContainerHeader from 'components/ContainerHeader';
import CardBox from 'components/CardBox';
import DataTable from 'components/customized/tables/datatable';
import {get, post, urlPrefix} from 'engine/dataServices';
import {Card, CardBody, CardFooter, CardHeader} from 'reactstrap';
import {NotificationManager} from 'react-notifications';
import Loading from 'app/loading';

const usersHeadTable = [
    {id: 'image', numeric: false, disablePadding: true, label: 'آواتار'},
    {id: 'username', numeric: false, disablePadding: true, label: 'نام کاربری'},
    {id: 'notification', numeric: false, disablePadding: true, label: 'فعال بودن Notification'},
    {id: 'email', numeric: false, disablePadding: true, label: 'ایمیل'},
    {id: 'lastLoginDate', numeric: false, disablePadding: true, label: 'تاریخ آخرین ورود'},
    {id: 'createdDate', numeric: true, disablePadding: false, label: 'تاریخ ایجاد'},
    {id: 'sendTo', numeric: true, disablePadding: false, label: 'ارسال'},
];

class BroadCast extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            formFunctionType: 'message',
            usersData: [],
            sendToData: [],
            payedData: [],
            searchTxt: '',
            setMessageContainer: false,
            message: ''
        }

        this.myRef = React.createRef();
        jMoment.loadPersian({dialect: 'persian-modern'});
    }

    componentWillMount() {
        this.loadUsersData();
    }

    async loadUsersData() {
        const res = await get('User/GetAll');
        if (res.status == 200) {
            const responseData = await res.json();
            const _data = [];

            responseData.map(x => {
                let userImage = (x.Setting.UserImage) ? urlPrefix + x.Setting.UserImage : require('assets/Images/TolitonAvatar.png');
                let notificationRender = (x.Setting.EnableNotification) ? <Done style={{color: 'green'}}/> :
                    <Clear style={{color: 'red'}}/>;

                let sendToRender = <Button onClick={this.rowAddButton.bind(this, x.Mobile)}><AddAlert/></Button>


                _data.push({
                    image: <Avatar src={userImage} className="size-20 mt-2 mb-2"
                                   style={{margin: 'auto'}}/>,
                    username: x.Mobile,
                    notification: notificationRender,
                    email: (x.Email) ? x.Email : 'فاقد ایمیل',
                    lastLoginDate: this.normalizeDates(x.LastLoginDate),
                    createdDate: this.normalizeDates(x.CreatedDate),
                    sendTo: sendToRender
                });
            });


            this.setState({usersData: _data});

        }
    }

    handleChange = prop => event => {
        this.setState({[prop]: event.target.value});
    };

    radioGroupBynHandleChange = (event, formFunctionType) => {
        if (formFunctionType == 'message')
            this.setState({formFunctionType});
        else
            alert('امکان در این نسخه فعال نمی باشد.');
    };

    rowAddButton(val) {
        const {usersData, addText, sendToData} = this.state;
        let exist = sendToData.find(x => x.username == val);
        if (!exist) {
            let _data = usersData.find(x => x.username == val);
            sendToData.push(_data);
            this.setState({sendToData: sendToData});
            this.search();
        } else {
            NotificationManager.error(`کاربر ${exist.username} در لیست ارسال موجود می باشد.`, 'خطای کاربر');
        }
    }

    handleSearchTextChange = prop => event => {
        this.setState({[prop]: event.target.value});
        this.search(event.target.value);
    };

    search(val, data) {
        let sendToData = [];
        if (data)
            sendToData = data;
        else
            sendToData = this.state.sendToData;

        let payedData = [];

        if (val)
            payedData = sendToData.filter(x => x.username.includes(val));
        else
            payedData = sendToData;

        this.setState({payedData: payedData});
    }

    handleChipDelete(val, data) {
        let {sendToData, searchTxt} = this.state;
        sendToData = sendToData.filter(x => x.username != val);
        this.setState({sendToData: sendToData});
        this.search(searchTxt, sendToData);
    }

    sendToAllBtn() {
        let {usersData, searchTxt} = this.state;
        let sendToData = usersData;
        this.setState({sendToData});
        this.search(searchTxt, sendToData);
    }

    setMessageBtn() {
        this.setState({setMessageContainer: true});
        this.scroll(this.myRef);
    }

    async submitBtn() {
        const validateResult = this.validation();

        if (validateResult) {
            try {
                this.handleLoading(true);
                const {sendToData, message} = this.state;
                let mobiles = sendToData.map(x => x.username);
                let sendToDataLen = sendToData.length;

                const res = await post('User/BroadCast', {Mobiles: mobiles, Message: message});
                if (res.status == 200) {
                    NotificationManager.success(`اطلاع رسانی برای ${sendToDataLen} کاربر با موفقیت انجام شد.`, 'عملیات موفق');
                }
            } catch (e) {
                console.log(e)
            } finally {
                this.handleLoading(false);
            }
        }
    }

    closeEditContainer() {
        this.setState({setMessageContainer: false});
        this.clearForm();
    }

    clearForm() {

    }

    scroll(ref) {
        setTimeout(() => {
            ref.current.scrollIntoView({behavior: 'smooth'})
        }, 100)
    }

    dynamicParametersBtn(val) {
        let {message} = this.state;
        message = `${message} [${val}] `;
        this.setState({message});
    }

    validation() {
        const {message, sendToData} = this.state;
        let isValid = true;

        if (sendToData.length == 0) {
            isValid = false;
            NotificationManager.error('گیرنده ای انتخاب نشده است.', 'خطای کاربری');
        }

        const minValidLength = 20;
        if (message.length < minValidLength) {
            isValid = false;
            NotificationManager.error(`متن پیام باید بیش از ${minValidLength} کاراکتر باشد.`, 'خطای کاربری');
        }

        const startDynamics = message.split('[').length;
        const endDynamics = message.split(']').length;
        if (startDynamics != endDynamics) {
            isValid = false;
            NotificationManager.error('فرمت متن پیام صحیح نمی باشد.', 'خطای کاربری');
        }

        return isValid;
    }

    normalizeDates = (datetime) => jMoment(datetime).year() > 2000 ? jMoment(datetime).format('jYYYY/jMM/jDD') : '...';

    handleLoading = (status) => {
        this.setState({loading: status})
    }

    render() {
        const {formFunctionType, setMessageContainer, loading} = this.state;
        const {usersData, searchTxt, payedData, message, sendToData} = this.state;
        const sendToDataLen = sendToData.length;
        const messageLen = message.length;

        return (
            <div className="animated slideInUpTiny animation-duration-3">
                {loading && <Loading/>}

                <ContainerHeader match={this.props.match} title="اطلاع رسانی همگانی"/>

                <FormControl component="fieldset" style={{width: '100%', textAlign: 'center'}}>
                    <FormLabel component="legend">اطلاع رسانی از طریق</FormLabel>
                    <RadioGroup
                        className="d-flex flex-row justify-content-center"
                        aria-label="functionType"
                        name="functionType"
                        value={formFunctionType}
                        onChange={this.radioGroupBynHandleChange}
                    >
                        <FormControlLabel value="message" control={<Radio/>} label="ارسال پیامک"/>
                        <FormControlLabel value="mail" control={<Radio/>} label="ارسال ایمیل"/>
                        <FormControlLabel value="notification" control={<Radio/>} label="ارسال Notification"/>
                    </RadioGroup>
                </FormControl>

                <div className='row'>

                    <CardBox styleName="col-lg-8 col-md-8 col-12" heading="لیست کاربران" headerOutside>
                        <div>
                            <Button className='btn-primary mb-3' variant='raised'
                                    onClick={this.sendToAllBtn.bind(this)}>
                                <DoneAll/>
                                <span className='mr-3'>ارسال به همه</span>
                            </Button>
                            <DataTable columnData={usersHeadTable} data={usersData}/>
                        </div>
                    </CardBox>

                    <CardBox styleName="col-lg-4 col-md-4 col-12" heading="ارسال به" headerOutside>
                        <div>
                            <Button className='btn-secondary mb-4' variant='raised' fullWidth
                                    onClick={this.setMessageBtn.bind(this)}>
                                <LibraryBooks/>
                                <span className='mr-3'>تنظیم متن و ارسال</span>
                            </Button>
                            <FormControl className="mb-3" fullWidth>
                                <Input
                                    id="search"
                                    value={searchTxt}
                                    onChange={this.handleSearchTextChange('searchTxt')}
                                    endAdornment={<InputAdornment position="end"><Search/></InputAdornment>}
                                />
                            </FormControl>
                            <div>
                                <div className='text-center mb-2'>
                                    تعداد گیرنده های انتخاب شده: {sendToDataLen}
                                </div>
                                {payedData.map(x => {
                                        return (<Chip
                                            avatar={x.image}
                                            label={x.username}
                                            onDelete={this.handleChipDelete.bind(this, x.username)}
                                            style={{margin: 3}}
                                        />)
                                    }
                                )}
                            </div>
                        </div>
                    </CardBox>
                </div>

                <div id="editContainer" ref={this.myRef} style={{paddingTop: 5}}>
                    {setMessageContainer &&
                    <Card className={`shadow border-0`} style={{marginTop: 25}}>
                        <CardHeader className="bg-primary text-white">تنظیم متن پیام و ارسال</CardHeader>
                        <CardBody>
                            <form className="row" noValidate autoComplete="off">
                                <div className="col-lg-7 col-md-7 col-12">
                                    <div className='row' style={{alignItems: 'baseline'}}>
                                        <h3>مقادیر پویا:</h3>
                                        <Chip
                                            label='موبایل'
                                            style={{marginRight: 8}}
                                            onClick={this.dynamicParametersBtn.bind(this, 'Mobile')}
                                        />
                                        <Chip
                                            label='نام'
                                            style={{marginRight: 8}}
                                            onClick={this.dynamicParametersBtn.bind(this, 'FirstName')}
                                        />
                                        <Chip
                                            label='نام خانوادگی'
                                            style={{marginRight: 8}}
                                            onClick={this.dynamicParametersBtn.bind(this, 'LastName')}
                                        />
                                        <Chip
                                            label='نام و نام خانوادگی'
                                            style={{marginRight: 8}}
                                            onClick={this.dynamicParametersBtn.bind(this, 'FullName')}
                                        />
                                        <Chip
                                            label='نام مستعار'
                                            style={{marginRight: 8}}
                                            onClick={this.dynamicParametersBtn.bind(this, 'NickName')}
                                        />
                                    </div>
                                    <p className='mt-3'>
                                        متن خود را در کادر زیر وارد نموده و با استفاده از مقادیر پویای فوق می توانید
                                        مانند راهنمایی مقابل بخش های پویا را به متن خود در هنگام ارسال پیام اضافه
                                        نمایید.
                                    </p>
                                    <TextField
                                        id="multiline-flexible"
                                        label="متن پیام"
                                        multiline
                                        rowsMax="6"
                                        rows="5"
                                        value={message}
                                        onChange={this.handleChange('message')}
                                        margin="normal"
                                        fullWidth
                                    />
                                    <p>تعداد کلمه های پیام: {messageLen}</p>
                                </div>
                                <div className="col-lg-5 col-md-5 col-12">
                                    <Card className={'shadow border-0 bg-secondary'}>
                                        <CardBody className="text-center">
                                            <h3 className="card-title">راهنمایی!</h3>
                                            <p>
                                                سلام [FirstName] گرامی،
                                                تولیتون به مناسبت سال 1399 محصولات جدید و خاص تدارک دیده است.
                                                به اپلیکیشن خود با شماره موبایل [Mobile] وارد شوید.
                                            </p>
                                            <h4>
                                                تبدیل خواهد شد به:
                                            </h4>
                                            <p>
                                                سلام حسین گرامی،
                                                تولیتون به مناسبت سال 1399 محصولات جدید و خاص تدارک دیده است.
                                                به اپلیکیشن خود با شماره موبایل 09126269063 وارد شوید.
                                            </p>
                                        </CardBody>
                                    </Card>
                                </div>
                            </form>
                        </CardBody>
                        <CardFooter>
                            <div style={{textAlign: 'left'}}>
                                <Button variant="raised" className="jr-btn bg-success jr-btn-sm text-white"
                                        style={{marginLeft: 10}} onClick={this.submitBtn.bind(this)}>
                                    <i className="zmdi zmdi-check zmdi-hc-fw"/>
                                    <span>ارسال</span>
                                </Button>
                                <Button variant="raised" className="jr-btn bg-red jr-btn-sm text-white"
                                        style={{marginLeft: 10}} onClick={this.closeEditContainer.bind(this)}>
                                    <i className="zmdi zmdi-close zmdi-hc-fw"/>
                                    <span>انصراف</span>
                                </Button>
                            </div>
                        </CardFooter>
                    </Card>
                    }
                </div>
            </div>
        );
    }
}

export default BroadCast;



// WEBPACK FOOTER //
// ./app/routes/toliton/broadcast/broadcast.js